import { render } from "./DbsReservationStatusButtons.vue?vue&type=template&id=8128f9d6&scoped=true"
import script from "./DbsReservationStatusButtons.vue?vue&type=script&lang=js"
export * from "./DbsReservationStatusButtons.vue?vue&type=script&lang=js"

import "./DbsReservationStatusButtons.vue?vue&type=style&index=0&id=8128f9d6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8128f9d6"

export default script